import React , {useEffect, useState } from 'react'
import { useStore} from './store/comercioStore'
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Autocomplete from '@mui/material/Autocomplete';

import CircularProgress from '@mui/material/CircularProgress';
import Footer from './Footer';
//import datos from './provincias.json';

function PanelComercios() {
  const [loading, setLoading] = useState(false);

      const [centrosComerciales,setCentrosComerciales] = useState([]);
      const [selectedOption, setSelectedOption] = useState(null);
      const [open, setOpen] = useState(false);
      const [sucursales,setSucursales] = useState([]);
      const [link,setLink] = useState('');
      const [calle,setCalle] = useState('');
      const [whatsapp,setWhatsapp] = useState('');
      const [nombredefantasia,setNombredefantasia] = useState('');
      
      const [numero,setNumero] = useState('');
      const { comercioId , esSocio } = useStore();
      const [selectedOptionRubros, setSelectedOptionRubros] = useState(null);
      const [selectedOptionProvincia, setSelectedOptionProvincia] = useState(null);
      const [selectedOptionLocalidad, setSelectedOptionLocalidad] = useState(null);
      const [rubros,setRubros] = useState([]);

      
      const [provincias,setProvincias] = useState([]);
      const [localidades,setLocalidades] = useState([]);
      
      const handleOptionChangeRubros = (event, value) => {
        setSelectedOptionRubros(value);
      };

      const getRubros = () => {
        const baseURL = process.env.REACT_APP_SERVER_PATH+'rubrostodos';
        fetch(`${baseURL}`)
        .then(res => res.json())
        .then(
          (result) => { setRubros(result) 
          },
          (error) => {
          }
        )
       }

       const getProvincias = () => {
        const baseURL = process.env.REACT_APP_SERVER_PATH  + 'getProvincias';
        fetch(`${baseURL}`)
        .then(res => res.json())
        .then(
          (result) => { setProvincias(result) 
          },
          (error) => {
          }
        )
       }

       const getLocalidades = (selected) => {
        const baseURL = process.env.REACT_APP_SERVER_PATH  + 'getLocalidades/'+selected;
        fetch(`${baseURL}`)
        .then(res => res.json())
        .then(
          (result) => { setLocalidades(result) 
          },
          (error) => {
          }
        )
       }

      const handleOptionChangeLocalidades = (event , value) => {
        setSelectedOptionLocalidad(value.localidad);
        getCentrosComerciales(value.localidad);
      }

      const handleOptionChangeProvincias = (event, value) => {
        setSelectedOptionProvincia(value.provincia);
        // cambio las localidad segun la provincia selecconada
        getLocalidades(value.provincia);
        if (value.provincia != null) {
           // getLocalidades(value.provincia);
          }
        else 
          {
          //setLocalidades([]);
          }
      }
      
      const handleOptionChange = (event, value) => {
        setSelectedOption(value);
      };

      const getSucursales = () => {
        const baseURL = process.env.REACT_APP_SERVER_PATH+'getSucursales/'+comercioId;
        fetch(`${baseURL}`)
        .then(res => res.json())
        .then(
              (result) => {
                  setSucursales(result);
              },
          (error) => {
          }
        )
       }

       const handleDelete = async(id) => {
        try {
          const baseURL = process.env.REACT_APP_SERVER_PATH + 'deleteSucursal/'+id;
          const res = await fetch(`${baseURL}`, {
            method: "delete",
            headers: {
              "Content-Type": "application/json",
              "x-access-token": "token-value",
              'Access-Control-Allow-Origin': '*'
            }
          });
         // setOpen(false); // cierra ventana para todos los casos
          if (( res.status === 200 ) || ( res.status === 204 ) || ( res.status === 304 )) {
              getSucursales();
              //setMensaje('Eliminación Correcta');
               //handleClickMsg();
                }
          else
              if ( res.status === 505 ) {
                 // setMensaje('NO se puede eliminar, existen INSCRIPCIONES en esta Sucursal');
                 // setOpenMsgError(true);
                  console.log('Error al eliminar la sucursal');
                  } 
              else    
                  { 
                    //setMensaje('Error al eliminar');
                    //setOpenMsgError(true);
                  }
              } 
              catch (err) {
                console.log(err.message)
              }
      };
    
       const getCentrosComerciales = (valor) => {
        const baseURL = process.env.REACT_APP_SERVER_PATH+'getCentrosComerciales/'+selectedOptionProvincia+'/'+valor;
       console.log(baseURL);
        fetch(`${baseURL}`)
        .then(res => res.json())
        .then(      
          (result) => { setCentrosComerciales(result) 
          },
          (error) => {
          }
        )
       }

       const postSucursal = async (event) => {
       if (calle !== '' && numero !== '' && selectedOption.idcentrocomercial !== undefined) {  
        event.preventDefault();
          //
          const postData = {
              calle : calle,
              numero : numero,
              idcomercio : comercioId,
              idcentrocomercial : selectedOption.idcentrocomercial, // asi el id del campo
              nombredefantasia : nombredefantasia,
              idrubro : selectedOptionRubros.idrubro, //selectedOptionRubros
              whatsapp : whatsapp,
              provincia : selectedOptionProvincia, // asi es el nombre del campo
              localidad : selectedOptionLocalidad
            };
        try {
                  const baseURL = process.env.REACT_APP_SERVER_PATH + 'addSucursal';
                  const res = await fetch(`${baseURL}`, {
                    method: "post",
                    headers: {
                      "Content-Type": "application/json",
                      "x-access-token": "token-value",
                      'Access-Control-Allow-Origin': '*'
                    },
                    body: JSON.stringify(postData),
                  });
        
                  if (res.status === 200) {
                    handleClose();
                    getSucursales() 
                    } 
                  else
                  {
                    // setMsgno(true);
                  }
                      } catch (err) {
                    console.log(err.message)
                }
              //
      }
    };

       const handleClickOpen = () => {
        setNumero('');
        setCalle('');
        setNombredefantasia('');
        setWhatsapp('');
        setSelectedOption(0);
        setOpen(true);
      };
 
      const handleClose = () => {
        setOpen(false);
      };

       const armaLink = (valor) => {
        setLoading(true);
            // toma la URL actual
            let cadena = window.location.href;
            // le quita: menucomercio 
            let cadena2 = cadena.split("menucomercio").join("");
            // arma el llamado a la API con el link del QR 
            window.open(process.env.REACT_APP_SERVER_PATH+'download/?link='+cadena2+"inscripciones/"+valor, "_blank");
            setLoading(false);
       } 
/*
       const downloadQR = () => {
        const svg = document.getElementById("QRCode");
        const svgData = new XMLSerializer().serializeToString(svg);
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const img = new Image();
        img.onload = () => {
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);
          const pngFile = canvas.toDataURL("image/png");
          const downloadLink = document.createElement("a");
          downloadLink.download = "QRCode";
          downloadLink.href = `${pngFile}`;
          downloadLink.click();
        };
        img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
      };
*/
      useEffect(() => {  

        getProvincias();     
        getSucursales(); 
        getCentrosComerciales();
        getRubros();
        // eslint-disable-next-line    
    },[])

  return (
    <>
    <Container component="main" maxWidth="lg" style={{ marginTop: "30px",marginBottom: "30px"}}>

        <h1>Sucursales:</h1>
        <Button variant="outlined" onClick={handleClickOpen} sx={{ mt: 3, mb: 1 }}>
        Nueva Sucursal
      </Button>
      {loading ? <CircularProgress size={24} color="inherit" /> : ''}

        <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Datos de la nueva sucursal</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Con estos datos, podrá generar el QR de la nueva sucursal
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Nombre de Fantasia"
            type="text"
            fullWidth
            variant="standard"
            value = {nombredefantasia}
            onChange = {(e) => setNombredefantasia(e.target.value)}
          />
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Whatsapp"
            type="text"
            fullWidth
            variant="standard"
            value = {whatsapp}
            onChange = {(e) => setWhatsapp(e.target.value)}
          />
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Calle"
            type="text"
            fullWidth
            variant="standard"
            value = {calle}
            onChange = {(e) => setCalle(e.target.value)}
          />
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Número"
            type="number"
            fullWidth
            variant="standard"
            value = {numero}
            onChange = {(e) => setNumero(e.target.value)}
          />
                         
                <Autocomplete sx = {{mt : 2}}
                id="auto"
                options={provincias}
                getOptionLabel={(provincias) => provincias.provincia}
                renderInput={(params) => <TextField {...params} label="Provincia" variant="outlined" />}
                onChange={handleOptionChangeProvincias}
                />
           
                <Autocomplete sx = {{mt : 2}}
                id="auto"
                options={localidades}
                getOptionLabel={(localidades) => localidades.localidad}
                renderInput={(params) => <TextField {...params} label="Localidad" variant="outlined" />}
               onChange={handleOptionChangeLocalidades}
                //onChange = {(e) => {setSelectedOptionLocalidad( e.target.value)}}
                />
             

           <Autocomplete sx = {{mt : 2}}
                id="auto"
                options={centrosComerciales}
                getOptionLabel={(centrosComerciales) => centrosComerciales.descripcion}
                renderInput={(params) => <TextField {...params} label="Centro Comercial" variant="outlined" />}
                onChange={handleOptionChange}
                />
                <Autocomplete sx = {{mt : 2}}
                id="auto"
                options={rubros}
                getOptionLabel={(rubros) => rubros.detalle}
                renderInput={(params) => <TextField {...params} label="Rubro" variant="outlined" />}
                onChange={handleOptionChangeRubros}
                />
           
        </DialogContent>
        <DialogActions sx = {{mb : 2,mr : 2}}>
          <Button  variant="contained"color="secondary" onClick={()=>handleClose()}>Cancelar</Button>
          <Button  variant="contained"color="primary" onClick={postSucursal}>Registrar</Button>
        </DialogActions>
      </Dialog>
        <TableContainer component={Paper} sx={{ mt: 3, mb: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
              <TableCell>ID</TableCell>
                <TableCell>Calle</TableCell>
                <TableCell>Numero</TableCell>
                <TableCell>Centro comercial</TableCell>
                <TableCell>Acciones</TableCell> 
              </TableRow>
            </TableHead>
            <TableBody>
              {sucursales.map((item,index)=>(
                <TableRow key={index + 1}>
                   <TableCell>{item.idcomerciosucursal}</TableCell>
                  <TableCell>{item.calle}</TableCell>
                  <TableCell>{item.numero}</TableCell>
                  <TableCell>{item.descripcion}</TableCell>
                  <TableCell>
                    <Button variant="outlined" color="primary" onClick={()=>{armaLink(item.idcomerciosucursal)}}>Genera QR</Button>
                    <Button variant="outlined" color="secondary" onClick={()=> handleDelete(item.idcomerciosucursal)}>Eliminar</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      <div style={{visibility: 'hidden'}}>
      <TextField
              margin="normal"
              required
              fullWidth
              name="QR"
              label="QR"
              type="text"
              id="QR"
              autoComplete="current-password"
              value={link}
              onChange = {(e) => setLink(e.target.value)}
            /> 
      </div>
                <Footer />
      <Grid container spacing={1}>
</Grid>
    </Container>
    
     </>
  )
}

export default PanelComercios